export default __webpack_public_path__ + "static/aboutWebp-1bd141cb8911b221d22467a8e0eead80.webp";